import { extractWebsite } from '@design-system/embed';
import { getAspectRatio } from './getAspectRatio';
/**
 * Checks wether the URL is an embedly URL
 */
const embedlyUrlPattern = /cdn.embedly.com/u;
/**
 * Identifies the embed source URL in the embedly URL
 * - capture group 1: source url
 */
const urlPattern = /url=([^&]+)/u;
/**
 * Identifies the provider name in the embedly URL.
 * - capture group 1: display name of the provider
 */
const displayNamePattern = /display_name=([^&]+)/u;
export const extractConsentGuardProps = (iframe) => {
    var _a, _b, _c, _d;
    const isEmbedly = embedlyUrlPattern.test(iframe.src);
    let sourceUrl = iframe.src;
    let providerName = '';
    // For embedly content, we need to extract the source URL and provider name
    // from the iframe URL
    if (isEmbedly) {
        const encodedSourceUrl = (_b = (_a = sourceUrl.match(urlPattern)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : '';
        sourceUrl = decodeURIComponent(encodedSourceUrl);
        providerName = (_d = (_c = iframe.src.match(displayNamePattern)) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : '';
    }
    const hostName = extractWebsite(sourceUrl) || '';
    const aspectRatio = getAspectRatio(iframe);
    providerName || (providerName = hostName);
    return {
        hostName,
        providerName,
        aspectRatio,
    };
};
//# sourceMappingURL=extractConsentGuardProps.js.map